import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appWholeNumberOnly]',
    standalone: false
})
export class WholeNumberOnlyDirective {

  private regex: RegExp = new RegExp(/^\d*$/);

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    // Allow: Backspace, Delete, Tab, Escape, Enter, and .
    if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'].indexOf(event.key) !== -1 ||
      // Allow: Ctrl+A
      (event.key === 'a' && (event.ctrlKey || event.metaKey)) ||
      // Allow: Ctrl+C
      (event.key === 'c' && (event.ctrlKey || event.metaKey)) ||
      // Allow: Ctrl+V
      (event.key === 'v' && (event.ctrlKey || event.metaKey)) ||
      // Allow: Ctrl+X
      (event.key === 'x' && (event.ctrlKey || event.metaKey)) ||
      // Allow: home, end, left, right
      ['Home', 'End', 'ArrowLeft', 'ArrowRight'].indexOf(event.key) !== -1) {
      // let it happen, don't do anything
      return;
    }

    // Ensure that it is a number and stop the keypress
    if (!this.regex.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event']) onInput(event: Event) {
    const input = this.el.nativeElement as HTMLInputElement;
    const inputValue = input.value;

    if (!this.regex.test(inputValue)) {
      input.value = inputValue.replace(/[^0-9]/g, '');
    }
  }
}
